import { Step } from '@/utils/interfaces'
import { onBeforeUpdate, ref } from '@vue/composition-api'

export const stepperComposition = (
  onComplete?: (...args: any[]) => Promise<any>,
) => {
  const model = ref(1)

  const components = ref<Step[]>([])

  onBeforeUpdate(() => {
    components.value = []
  })

  const onNext = async (...args: any[]) => {
    const currentStep = components.value[model.value - 1]
    const response = await currentStep.onNext()
    if (response) {
      if (model.value === components.value.length) {
        onComplete?.(...args)
      } else {
        model.value++
      }
    }
  }

  const onPrev = () => {
    model.value = Math.max(1, model.value - 1)
  }

  return {
    components,
    onNext,
    onPrev,
    model,
  }
}
